module.exports = __webpack_public_path__ + "static/media/IMG_0517y.8c483078.jpg";